import React, { Component } from 'react';
import { ProductCategories, RegistrationDetails } from '../components';
import { HttpService } from '../services';

export default class Register extends Component {
	constructor(props) {
		super(props);

		this.httpService = new HttpService();
	}

	render() {
		return (
			<div className="register-container">
				<RegistrationDetails httpService={this.httpService} />
				<ProductCategories httpService={this.httpService} />
			</div>
		);
	}
}
